import { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  Grid,
  Typography,
  Select,
  MenuItem,
  useTheme,
  useMediaQuery,
  TextField,
  FilledTextFieldProps,
  OutlinedTextFieldProps,
  StandardTextFieldProps,
  TextFieldVariants,
} from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import "dayjs/locale/th";

dayjs.extend(buddhistEra);
export default function DateStatusRange() {
  const [docType, setDocType] = useState("NDA");
  const [status, setStatus] = useState("ทั้งหมด");
  const [startDate, setStartDate] = useState<Dayjs | null>(dayjs());
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));

  const formatThaiYear = (date: Dayjs | null) => {
    return date && dayjs.isDayjs(date) ? date.format("DD/MM") + `/${date.year() + 543}` : "";
  };

  const handleStartDateChange = (date: Dayjs | null) => {
    setStartDate(date);
    if (date && endDate && date.isAfter(endDate)) {
      setEndDate(date); // ปรับวันที่สิ้นสุดให้เท่ากับวันที่เริ่มต้นถ้าวันที่เริ่มต้นใหม่มากกว่า
    }
  };

  const handleEndDateChange = (date: Dayjs | null) => {
    if (date && startDate && date.isBefore(startDate)) return;
    setEndDate(date);
  };

  return (
    <Grid container
      spacing={2}
      direction={isLgUp ? "row" : "column"} // แนวตั้งเมื่อเป็น xs, sm, md
      sx={{
        mt: 2,
        alignItems: isLgUp ? "center" : "flex-start",
        flexWrap: "wrap",
        justifyContent: isLgUp ? "space-between" : "flex-start",
      }}>
      {/* Date Picker */}
      <Grid item sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
        {/* <Typography variant="body1" sx={{ mr: 1, fontFamily: "Sarabun, sans-serif" }}>
          ระยะเวลาที่ค้นหา:
        </Typography> */}
        {/* <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="th">
          <DatePicker
            label="วันที่เริ่มต้น"
            value={startDate ? dayjs(startDate, "DD/MM/YYYY") : null}
            onChange={handleStartDateChange}
            format="DD/MM/YYYY"
            slots={{ textField: TextField }}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  width: "150px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "20px",
                  },
                },
              },

            }}
          />
          <Typography sx={{ mx: 1 }}>→</Typography>
          <DatePicker
            label="วันที่สิ้นสุด"
            value={endDate ? dayjs(endDate, "DD/MM/YYYY") : null}
            onChange={handleEndDateChange}
            format="DD/MM/YYYY"
            slots={{ textField: TextField }}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  width: "150px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "20px",
                  },
                },
              },
            }}
          />
        </LocalizationProvider> */}

      </Grid>
      {/* <Typography>
        Start Date (Thai Year): {formatThaiYear(startDate)}
      </Typography>
      <Typography>
        End Date (Thai Year): {formatThaiYear(endDate)}
      </Typography> */}

      {/* Document Type Selector */}
      {/* <Grid item sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body1" sx={{ mr: 1, fontFamily: "Sarabun, sans-serif" }}>
          ประเภทเอกสาร:
        </Typography>
        <Select
          value={docType}
          onChange={(e: any) => setDocType(e.target.value)}
          displayEmpty
          sx={{
            borderRadius: "20px",
            height: "40px",
            border: "0px 1px solid #C7C7C7",
            backgroundColor: "#fff",
            minWidth: 100,
            fontFamily: "Sarabun, sans-serif",
          }}
        >
          <MenuItem value="NDA" sx={{ fontFamily: "Sarabun, sans-serif" }}>
            NDA
          </MenuItem>
          <MenuItem value="DSA" sx={{ fontFamily: "Sarabun, sans-serif" }}>
            DSA
          </MenuItem>
        </Select>
      </Grid> */}

      {/* Status Selector */}
      {/* <Grid item sx={{ display: "flex", alignItems: "center", }}>
        <Typography variant="body1" sx={{ mr: 1, fontFamily: "Sarabun, sans-serif" }}>
          สถานะ:
        </Typography>
        <Select
          value={status}
          onChange={(e: any) => setStatus(e.target.value)}
          displayEmpty
          sx={{
            borderRadius: "20px",
            height: "40px",
            border: "0px 1px solid #C7C7C7",
            backgroundColor: "#fff",
            minWidth: 120,
            padding: "4px 10px",
            fontFamily: "Sarabun, sans-serif",
          }}
        >
          <MenuItem value="ทั้งหมด" sx={{ fontFamily: "Sarabun, sans-serif" }}>
            ทั้งหมด
          </MenuItem>
          <MenuItem value="เสร็จสิ้น" sx={{ fontFamily: "Sarabun, sans-serif" }}>
            เสร็จสิ้น
          </MenuItem>
          <MenuItem value="ยกเลิก" sx={{ fontFamily: "Sarabun, sans-serif" }}>
            ยกเลิก
          </MenuItem>
        </Select>
      </Grid> */}
    </Grid>
  );
}
